// src/services/reportsService.js
import { apiRequest, downloadFile } from './api';

export const reportsService = {
    // Get attendance report
    getAttendanceReport: async (filters = {}) => {
        try {
            const response = await apiRequest.get('/reports/attendance', { params: filters });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch attendance report');
        }
    },

    // Get sales agents report
    getSalesAgentsReport: async (filters = {}) => {
        try {
            const response = await apiRequest.get('/reports/sales-agents', { params: filters });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch sales agents report');
        }
    },

    // Get staff performance report
    getPerformanceReport: async (filters = {}) => {
        try {
            const response = await apiRequest.get('/reports/performance', { params: filters });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch performance report');
        }
    },

    // Get late arrivals report
    getLateArrivalsReport: async (filters = {}) => {
        try {
            const response = await apiRequest.get('/reports/late-arrivals', { params: filters });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch late arrivals report');
        }
    },

    // Get premises analytics
    getPremisesAnalytics: async (filters = {}) => {
        try {
            const response = await apiRequest.get('/reports/premises', { params: filters });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch premises analytics');
        }
    },

    // Get geofence violations report
    getGeofenceReport: async (filters = {}) => {
        try {
            const response = await apiRequest.get('/reports/geofence', { params: filters });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch geofence report');
        }
    },

    // Get monthly summary
    getMonthlySummary: async (filters = {}) => {
        try {
            const response = await apiRequest.get('/reports/monthly', { params: filters });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch monthly summary');
        }
    },

    // Export report
    exportReport: async (reportType, format = 'csv', filters = {}) => {
        try {
            const filename = `${reportType}_report_${new Date().toISOString().split('T')[0]}.${format}`;

            // Build query parameters
            const queryParams = new URLSearchParams({
                export: format,
                date_from: filters.start_date || filters.date_from || '',
                date_to: filters.end_date || filters.date_to || '',
                premises_id: filters.premises_id || '',
                attendance_type: filters.attendance_type || '',
                consider_public_holidays: filters.consider_public_holidays === false ? '0' : '1',
                status_filter: filters.status_filter || 'all',
                ...(filters.organization_id && { organization_id: filters.organization_id })
            });

            await downloadFile(`/reports/${reportType}?${queryParams.toString()}`, filename);
            return true;
        } catch (error) {
            throw new Error(error.message || 'Failed to export report');
        }
    },

    // Get dashboard statistics
    getDashboardStats: async () => {
        try {
            const response = await apiRequest.get('/dashboard/stats');
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch dashboard statistics');
        }
    }
};
